import { Set as ISet } from 'immutable';

import { hasFaceplates } from '../faceplate/faceplateSelectors';
import { catalogsAreLoaded } from '../catalogs/catalogSelectors';
import { canAddDigitalItem, canAddPlasticItem } from '../item/itemSelectors';
import { IS_PLASTIC_FIELD } from '../item/newItemForm';

import cardTypeMessages from './cardTypeMessages';
import { cardTypeStepPostConditions, cardTypeStepPreConditions, cardTypeStepSkippable } from './cardTypeStepSelectors';


const cardTypeConfig = {
    component: () => import('./CardTypeStep'),
    flow: 'buy',
    isReady: state => (
        hasFaceplates(state) && catalogsAreLoaded(state)
    ),
    canLoad: (state, ownProps) => {
        const shouldLoad = (canAddPlasticItem(state) && canAddDigitalItem(state));
        let flowProgress = null;
        if (!shouldLoad) {
            
            flowProgress = ISet([IS_PLASTIC_FIELD]);
        }
        return { isAllowedOrPath: (shouldLoad || ownProps.submitPath), flowProgress };
    },
    preConditions: cardTypeStepPreConditions,
    postConditions: cardTypeStepPostConditions,
    getSubmitMessage: () => cardTypeMessages.submitButtonText,
    canSkip: state => (
        cardTypeStepSkippable(state)
    )
};

export default cardTypeConfig;
